import React from 'react';
import PropTypes from 'prop-types';

export class FormRow extends React.Component {
    render() {
        return <div className="form-row">{this.props.children}</div>;
    }
}

FormRow.propTypes = {
    children: PropTypes.node,
};

export default FormRow;
